<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-产品子分类-添加
    -->
    <el-dialog
    title="添加产品子分类"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
         <!-- 产品子分类名称 -->
    <el-form-item label="产品子分类名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入产品子分类名称" class="max-w460"></el-input>
    </el-form-item>

    <!-- 产品单价 -->
    <el-form-item label="单价" prop="price">
        <el-input v-model="form.price" placeholder="请输入单价" class="max-w460"></el-input>
    </el-form-item>

    <!-- 产品单位 -->
    <el-form-item label="单位" prop="unit">
        <el-input v-model="form.unit" placeholder="请输入单位" class="max-w460"></el-input>
    </el-form-item>

    <!-- 计价方式 -->
    <el-form-item label="计价方式" prop="price_method">
        <el-input v-model="form.price_method" placeholder="请输入计价方式" class="max-w460"></el-input>
    </el-form-item>

    <!-- 最小长度 -->
    <el-form-item label="最小长度" prop="min_length">
        <el-input v-model="form.min_length" placeholder="请输入最小长度" class="max-w460"></el-input>
    </el-form-item>

    <!-- 最大长度 -->
    <el-form-item label="最大长度" prop="max_length">
        <el-input v-model="form.max_length" placeholder="请输入最大长度" class="max-w460"></el-input>
    </el-form-item>

    <!-- 最小宽度 -->
    <el-form-item label="最小宽度" prop="min_width">
        <el-input v-model="form.min_width" placeholder="请输入最小宽度" class="max-w460"></el-input>
    </el-form-item>

    <!-- 最大宽度 -->
    <el-form-item label="最大宽度" prop="max_width">
        <el-input v-model="form.max_width" placeholder="请输入最大宽度" class="max-w460"></el-input>
    </el-form-item>

    <!-- 计价公式 -->
    <el-form-item label="计价公式" prop="formula">
        <el-input v-model="form.formula" placeholder="请输入计价公式" class="max-w460"></el-input>
    </el-form-item>

    <!-- 供应商ID -->
    <el-form-item label="供应商ID" prop="supply_id">
        <el-input v-model="form.supply_id" placeholder="请输入供应商ID" class="max-w460"></el-input>
    </el-form-item>

    <!-- 产能 -->
    <el-form-item label="产能" prop="capacity">
        <el-input v-model="form.capacity" placeholder="请输入产能" class="max-w460"></el-input>
    </el-form-item>

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import Hproduct_subcategoryApi from '@/api/hproduct_subcategory.js';

import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name:"",
        price:"",
        unit:"",
        price_method:"",
        min_length:"",
        max_length:"",
        min_width:"",
        max_width:"",
        formula:"",
        supply_id:"",
        capacity:"",

      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入产品子分类名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {

    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
    
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Hproduct_subcategoryApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/hproduct_subcategory/index/part/add.vue